// eslint-disable-next-line import/prefer-default-export
export function setProgress (state, timeProgress) {
    state.timeProgress = timeProgress;
}
